import { CONFIG } from '../core/config';
import { ModifiableEntity } from './editable-entity';
import { Unit } from './unit';
import { ViewModel } from './view-model';

export class NodeOutput extends ModifiableEntity implements ViewModel {
  readonly friendlyTypeNameSingular = 'Node Output';
  readonly apiRoute: string = CONFIG.apiRoutes.nodeOutput;

  nodeOutputId: string;
  identifier: string;
  label: string;
  nodeId: string;
  node: Node;
  dataType: NodeOutputDataType = NodeOutputDataType.Number;
  uomId: string;
  UOM: Unit = new Unit();
  groupName: string;
  displayOnNodeTab: boolean;
  displayOnOutputTab: boolean;

  constructor() {
    super();
  }

  json() {
    return this;
  }

  loadFromJson(data: any) {
    super.loadFromJson(data);
    this.nodeOutputId = data.nodeOutputId;
    this.identifier = data.identifier;
    this.label = data.label;
    this.nodeId = data.nodeId;
    this.node = data.node;
    this.dataType = data.dataType;
    this.groupName = data.groupName;
    this.displayOnNodeTab = data.displayOnNodeTab;
    this.displayOnOutputTab = data.displayOnOutputTab;
    this.uomId = data.uomId;

    if (data.uom) {
      this.UOM = new Unit();
      this.UOM.loadFromJson(data.uom);
    }
  }
}

/**
 * Defines the type of data for a node output
 */
export enum NodeOutputDataType {
  Number = 1,
  Text = 2,
  DateTime = 3,
  Boolean = 4,
  Lookup = 5,
  Category = 6,
  ProbabilityCategory = 7,
  ConsequenceCategory = 8,
}
